'use strict';

import React, {useCallback, useEffect, useMemo} from 'react';
import {h, Fragment} from 'preact';
import {Link, useHistory} from 'react-router-dom';
import {trans} from '../../../l10n';
import {langPath} from '../../utility/url';
import {createPortal} from 'react-dom';

function BreadcrumbsDesktop(props) {
    const history = useHistory();

    if (!window.serverBreadcrumbsCleared) {
        const serverBreadcrumbs = document.querySelector('.wrap_breadcrumbs');

        if (serverBreadcrumbs) {
            serverBreadcrumbs.innerHTML = '';
        }

        window.serverBreadcrumbsCleared = true;
    }

    const target = useMemo(() => document.querySelector('.wrap_breadcrumbs'), []);
    const element = useMemo(() => document.createElement('div'), []);

    useEffect(() => {
        target.appendChild(element);

        return () => {
            target.removeChild(element);
        };
    }, []);

    const goBack = useCallback(() => {
        history.goBack();
    }, [history]);

    return createPortal(
        <>
            <div className='breadcrumbs'>
                <div className='wrap'>
                    <ul
                        className='sf-menu sf-menu-flex sf-js-enabled sf-arrows'
                        itemScope
                        itemType='http://schema.org/BreadcrumbList'>
                        {props.items.map((item, index) => {
                            const link =
                                index === 0 ? (
                                    <a itemProp='item' href={langPath(item.url)} title={item.title} rel='nofollow'>
                                        <span itemProp='name'>{item.title}</span>
                                    </a>
                                ) : (
                                    <Link itemProp='item' to={langPath(item.url)} title={item.title} rel='nofollow'>
                                        <span itemProp='name'>{item.title}</span>
                                    </Link>
                                );

                            if (index === props.items.length - 1) {
                                // Latest item
                                return (
                                    <li
                                        itemProp='itemListElement'
                                        itemScope
                                        itemType='http://schema.org/ListItem'
                                        key={item.url}>
                                        <span itemProp='name'>{item.title}</span>
                                        <meta itemProp='position' content={index + 1} />
                                    </li>
                                );
                            }

                            return (
                                <li
                                    itemProp='itemListElement'
                                    itemScope
                                    itemType='http://schema.org/ListItem'
                                    key={item.url}>
                                    {link}

                                    <meta itemProp='position' content={index + 1} />
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>

            <noindex is='noindex'>
                <a className='back border-r' href='#' onClick={goBack} rel='nofollow'>
                    {/*ВЕРНУТЬСЯ*/}
                    <span className='border-r'>{trans('breadcrumbs.go_back')}</span>
                </a>
            </noindex>

            <div className='clear'></div>
        </>,
        element
    );
}

export default BreadcrumbsDesktop;
